import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import ArticleView from '@/views/ArticleView.vue';
import ResultsView from '@/views/ResultsView.vue';
import Help from '@/views/Help.vue';
import About from '@/views/About.vue';
import LemmaList from '@/components/LemmaList.vue';
import { PROJECT_DISPLAY_NAME } from '@/constants';
import PageNotFound from '@/views/PageNotFound.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue'),
    meta: {
      title: 'Over het project'
    },
  },
  {
    path: '/docs/:title/:pid',
    component: () => import('../views/ArticleView.vue'),
  },
  {
    path: '/search',
    name: 'results',
    component: () => import('../views/ResultsView.vue'),
    meta: {
      title: 'Zoekresultaten'
    },
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/Help.vue'),
    meta: {
      title: 'Help'
    },
  },
  {
    path: '/lemmalist',
    name: 'lemmalist',
    component: LemmaList,
    meta: {
      title: 'Lemmalijst'
    },
  },

  // OLD URLs, STILL SUPPORTED
  {
    path: '/lemma/:title\\::pid',
    redirect: '/docs/:title/:pid'
  },
  {
    path: '/docs/:title',
    component: () => import('../views/ArticleView.vue'),
  },
  {
    path: '/lemma/:pid',
    component: () => import('../views/ArticleView.vue'),
  },

  {
    // will match everything
    path: '*',
    component: PageNotFound,
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  // Scroll to top (or to previous position when navigating history)
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {

  // If we're on a (cached) http version, send us to the correct https version.
  if (process.env.NODE_ENV !== 'development' && location.href.startsWith('http://lexiconfrisicum.ivdnt.org/')) {
    location.href = 'https://lexiconfrisicum.ivdnt.org/';
    return; // don't follow route
  }

  next();
});

// This callback runs after every route change
router.afterEach((to, from) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value.
  const appName = PROJECT_DISPLAY_NAME;
  
  // If we're viewing an article, use the article title as the document title instead of the fixed router one
  const titleFound = nearestWithTitle ? nearestWithTitle.meta.title : '';
  const replacedTitle = titleFound === '@@@ARTICLE' ? to.params.title : titleFound;
  document.title = titleFound.length > 0 ? `${replacedTitle} - ${appName}` : appName;
});

export default router
